import { render, staticRenderFns } from "./filter-panel-item.vue?vue&type=template&id=8d8d837e&"
import script from "./filter-panel-item.vue?vue&type=script&lang=js&"
export * from "./filter-panel-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports